import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { PusherService } from 'src/app/@shared/services/pusher.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { LoginComponent } from 'src/app/auth/login/login.component';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { RulesPageComponent } from 'src/app/pages/rules-page/rules-page.component';

declare var $: any;

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.css']
})
export class TopnavComponent extends BaseClass<any> implements OnInit {

  public user: any;
  searchData: any[] = [];
  public isLoggedin = false;
  public _pusher!: PusherService;
  @ViewChild('afterLoginModal', { static: false }) afterLoginModal?: ModalDirective;
  openafterLoginModal = false;
  public balInfo: any = {
    wall_amt: 0,
    net_expo: 0,
    bous: 0,
    avail_withdrawal: 0,
    await_bonus: 0
  }

  
  constructor(public router: Router,
    public service: WebserviceService,
    public _common: CommonService,
    private _message: MessageService,
    private _shared: SharedService,
    private injector: Injector) {
    super();

    //this.user = this.getLocalItem('user');

    this._shared.sharedLogin.subscribe(data => {
      if (data)
        this.showAfterLoginModal();
        // console.log("_shared.sharedLogin");
    });
    
    const sub1 = this._shared.sharedLoginModal.subscribe((res: any) => {
      if (res && res?.login) {
        this.openLogin('');
        res = undefined;
      }
    });
    this.subs.push(sub1);

    this.setBalanceInfo();

    if (this._common.getToken()) {
      this._pusher = injector.get<PusherService>(PusherService);
      this._pusher.userAccUpdate().subscribe(res => {
        if (res) {
          if (res.msg != '') {
            this._message.errmessage(res.msg);
            setTimeout(() => {
              this._common.removeLocalstorage();
              this.router.navigate(['/home']);
              window.location.reload();
            }, 1000)
          }
          if (this.userData) {
            this.userData.balance = parseFloat(res?.balance) + parseFloat(res?.expose) + parseFloat(res?.pl);
            this.userData.available_balance = parseFloat(res?.balance) + parseFloat(res?.expose) + parseFloat(res?.pl);
            this.userData.expose = res?.expose;
            localStorage.setItem(`${this.env.panel}user`, JSON.stringify(this.userData));
            this.setBalanceInfo();
          }
        }
      });

    }
  }

  ngOnInit(): void {
    this.handleroute(this.router.url);
    // let dts = (localStorage.getItem(`${this.env.panel}sideMenu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideMenu`) as any) : [];
    // this.searchData = dts;
    $(function () {
      var body = $('body');
      $('[data-toggle="minimize"]').on("click", function () {
        if ((body.hasClass('sidebar-toggle-display')) || (body.hasClass('sidebar-absolute'))) {
          body.toggleClass('sidebar-hidden');
        } else {
          body.toggleClass('sidebar-icon-only');
        }
      });
      $('[data-toggle="offcanvas"]').on("click", function () {
        $('.sidebar-offcanvas').toggleClass('active')
      });
    });
  }

  showAfterLoginModal() {
    if (localStorage.getItem(`${this.env.panel}popup`)) {
      // console.log("in");      
      this.afterLoginModal?.show();
      this.openafterLoginModal = true;
      localStorage.removeItem(`${this.env.panel}popup`);
    } else {
      // console.log('out');
      this.openafterLoginModal = false;
    }
  }

  closeSidebarIfOpen() {
    $('.sidebar-offcanvas').removeClass('active');
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  handleroute(url: any) {
    if (this._common.getToken()) {
      let pagesUrl: any[] = ['/sports/', '/reports/account-statement', '/home', '/dashboard', '/event/detail'];
      pagesUrl.forEach(element => {
        if (url.startsWith(element)) {
          this.getUserData();
        }
      });

    }
  }

  getUserData() {
    this.userData = this.getLocalItem('user');
    this.webSocketUrl = this.getLocalItem('ws', false);
    if (this.webSocketUrl) {
      this.getServices().Get(`${this.webSocketUrl + this.api.userData}/${this.userData?.id}`).subscribe(
        (res) => {
          if (res) {
            this.userData.balance = res.balance;
            this.userData.pl = res.pl;
            this.userData.available_balance = parseFloat(res.pl) + parseFloat(res.balance) + parseFloat(res.expose);
            this.userData.expose = res.expose;
            this.setLocalItem('user', this.userData);
            this.userData = this.getLocalItem('user');
          }
        },
        (err) => {
          console.log(err);
        });
    }
  }

  setBalanceInfo() {
    if (this.userData != null) {
      this.balInfo.wall_amt = this.fixedPostDecimal(this.userData?.available_balance);
      this.balInfo.net_expo = this.fixedPostDecimal(this.userData?.expose);
      this.balInfo.bonus = (this.userData?.pl < 0)
        ? this.fixedPostDecimal(parseFloat(this.userData?.balance) + parseFloat(this.userData?.pl))
        : this.fixedPostDecimal(this.userData?.balance);
      this.balInfo.avail_withdrawal = (this.userData?.pl < 0)
        ? 0.00
        : this.fixedPostDecimal(parseFloat(this.userData?.pl) - parseFloat(this.userData?.expose));
      this.balInfo.await_bonus = this.userData?.bonus_amount ? this.userData?.bonus_amount : 0;
    }
  }

  openLogin(e: any) {
    this._common.openModalWithComponent({ login: true }, LoginComponent, 'loginpopup')
  }

  openBonusRule() {
    this._common.openModalWithComponent({ bonus: true }, RulesPageComponent, 'bonus-rule')
  }

  openSignUpModal() {
    this._common.openModalWithComponent({ signUpModal: true }, LoginComponent, 'full-width-modal')
  }

  logOut() {
    this.getServices().Get(`${this.env.baseUrl + this.api.logout}`).subscribe(
      (res) => {
        this._common.removeLocalstorage();
        this._message.succmessage(res.message);
        this.router.navigate(['/home']);
        // window.location.reload();
      },
      (err) => {
        console.log(err);
      });
  }

  public wpLink = '';
  isChatIn: boolean = false;
  getContactInfo() {
    this.userData = this.getLocalItem('user');
    if (this.userData.username.toLowerCase() == this.env.demoLoginUserName) {
      this.wpLink = this.env?.host?.whatsapp != '' ? this.env?.host?.whatsapp : this.wpLink;
      // this.env.demoDWLink = this.env?.host?.whatsapp != '' ? this.env?.host?.whatsapp : this.env.demoDWLink;
      this.contactInfoApi('demo');
    } else {
      if (this.depoWithdrawCondition()) {
        // let url = `https://reddypanel.com/contact/reddybook.club/358417/Jnq8MNgo9g5R2SCDf8d35db89cdcdfc9d975bd67e0309d22`; //testURL
        this.contactInfoApi('');
      }
    }
  }
  contactInfoApi(key: any) {
    if (this.userData.contact_info != '') {
      let url = this.userData.contact_info.replace(':domain', this.env.host.domain);
      this.getServices().Get(url).subscribe(
        (res) => {
          if (res?.error == 0) {
            if (key == 'demo') {
              this.wpLink = this.env?.host?.whatsapp != '' ? this.env?.host?.whatsapp : res?.link;
            } else {
              this.wpLink = res?.link;
            }
            // this.env.demoDWLink = this.env?.host?.whatsapp != '' ? this.env?.host?.whatsapp : res?.link;
          }
        },
        (err) => {
          console.log(err);
        });
    }
  }

  ngDoCheck() {
    this.userData = (localStorage.getItem(`${this.env.panel}user`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}user`) as any) : '';
    this.isLoggedin = (localStorage.getItem(`${this.env.panel}id_token`) && localStorage.getItem(`${this.env.panel}user`)) ? true : false;
    // let dts = (localStorage.getItem(`${this.env.panel}sideMenu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideMenu`) as any) : [];
    // this.searchData = dts;
    if (this.isChatIn == false && this.isLogin()) {
      this.isChatIn = true;
      this.getContactInfo();
    }
    this.setBalanceInfo();
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

}
